import {mapActions, mapGetters, mapMutations} from "vuex";
import {Carousel, Slide} from 'vue-carousel';
import card from "@/modules/home/section/news/card/index.vue"

export default {
    name: "product-slider",
    props: {
        card: {
            type: String,
            default: ''
        }
    },
    components: {
        Carousel,
        Slide,
        card
    },
    data() {
        return {}
    },
    created() {
        this.fetchNews({
            orderBy:'asc'
        })
    },
    computed: {
        ...mapGetters({
            getNews: 'home/news'
        })
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchNews: 'home/NEWS'
        }),
        carouselNav($event, direction) {
            const carousel = this.$refs['carousel'];
            carousel.advancePage(direction);
        },
    }
}


